import {MenuItem, TextField} from '@mui/material'
import {EventStatusLabel} from '@widgets/common-shift-event'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {PROCESS_WORK_ORDER_STATUSES, ProcessWorkOrderStatus} from '../types'

type Props = {
  'data-test-id': string
  onChange: (newValue: ProcessWorkOrderStatus) => void
  value: ProcessWorkOrderStatus
}

export const ProcessWorkOrderStatusDropDown = ({
  onChange,
  value,
  'data-test-id': dataTestId
}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <TextField
      data-test-id={dataTestId}
      fullWidth
      label={t('task.label.status')}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value as ProcessWorkOrderStatus)
      }}
      select
      value={value}
      variant="filled"
      inputProps={{'data-test-id': `${dataTestId}-input`}}
    >
      {PROCESS_WORK_ORDER_STATUSES.map((status) => (
        <MenuItem key={status} value={status} data-test-id={`${dataTestId}-${status}`}>
          <EventStatusLabel status={status} />
        </MenuItem>
      ))}
    </TextField>
  )
}
